import { PropsWithChildren, useMemo } from 'react';
import {
  AnalyticsDataPageScreenType,
  AnalyticsDataProperty,
} from 'src/types/googleAnalyticsEvents';
import { useLanguagePairContext } from 'src/context/languagePair';
import { TrackedPageContext } from './context';

export type TrackedPageProviderProps = PropsWithChildren<{
  pageName: string;
  pageType: AnalyticsDataPageScreenType;
}>;

export const TrackedPageProvider = ({ children, pageName, pageType }: TrackedPageProviderProps) => {
  const { sourceLanguageLocale, targetLanguageLocale } = useLanguagePairContext();
  const value = useMemo(
    () => ({
      [AnalyticsDataProperty.pageScreenTypeSeo]: 'true' as const,
      [AnalyticsDataProperty.pageScreenName]: pageName,
      [AnalyticsDataProperty.pageScreenType]: pageType,
      [AnalyticsDataProperty.contentLanguage]: sourceLanguageLocale,
      [AnalyticsDataProperty.sourceLanguage]: sourceLanguageLocale,
      [AnalyticsDataProperty.targetLanguage]: targetLanguageLocale || null,
    }),
    [pageName, pageType, sourceLanguageLocale, targetLanguageLocale],
  );

  return <TrackedPageContext.Provider value={value}>{children}</TrackedPageContext.Provider>;
};
